module.exports = __webpack_public_path__ + "static/media/s4.026228c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/s4.jpg
// module id = 113
// module chunks = 0